__turbopack_context__.v({
  "apiDocsLink": "footer-module-scss-module__dNHyia__apiDocsLink",
  "column": "footer-module-scss-module__dNHyia__column",
  "columnTitle": "footer-module-scss-module__dNHyia__columnTitle",
  "content": "footer-module-scss-module__dNHyia__content",
  "contentWidth": "footer-module-scss-module__dNHyia__contentWidth",
  "footerGroupDivider": "footer-module-scss-module__dNHyia__footerGroupDivider",
  "linksContainer": "footer-module-scss-module__dNHyia__linksContainer",
  "logoPosition": "footer-module-scss-module__dNHyia__logoPosition",
  "navigation": "footer-module-scss-module__dNHyia__navigation",
  "panel": "footer-module-scss-module__dNHyia__panel",
  "panelArrow": "footer-module-scss-module__dNHyia__panelArrow",
  "stickyFooter": "footer-module-scss-module__dNHyia__stickyFooter",
  "supportEmailLink": "footer-module-scss-module__dNHyia__supportEmailLink",
});
